export default {
	meta: {
		title: 'Mot de passe',
		description: 'Mot de passe'
	},
	create: {
		action: {
			url: '/api/users/password?token={token}',
			method: 'patch'
		}
	},
	sendBtn: 'ME CONNECTER',

	title: 'Nouveau mot de passe',
	description: 'Minimum <strong>8 caractères alphanumériques</strong> avec au moins <strong>1 caractère spécial</strong> comme !, #, @, etc.',
	successMsg: 'Mot de passe modifié avec succès',
	backHomeBtn: 'Retour à l’accueil'
};
